import { Typography } from "@mui/material"
import Breadcrumbs from "@mui/material/Breadcrumbs"
import Chip from "@mui/material/Chip"
import { emphasize, styled } from "@mui/material/styles"
import { ReactElement } from "react"
import { useNavigate } from "react-router"

export interface IBreadcrumbProps {
	text: string
	icon: ReactElement | undefined
	path?: string
}

const Breadcrumb = ({
	breadcrumbVoices,
}: {
	breadcrumbVoices: IBreadcrumbProps[]
}) => {
	const navigate = useNavigate()
	const StyledBreadcrumb = styled(Chip)(({ theme }) => {
		const backgroundColor =
			theme.palette.mode === "light" ? "#FFF" : theme.palette.grey[800]
		return {
			backgroundColor,
			height: theme.spacing(3),
			color: theme.palette.text.primary,
			fontWeight: theme.typography.fontWeightRegular,
			"&:hover, &:focus": {
				backgroundColor: emphasize(backgroundColor, 0.06),
			},
			"&:active": {
				boxShadow: theme.shadows[1],
				backgroundColor: emphasize(backgroundColor, 0.12),
			},
		}
	}) as typeof Chip

	return (
		<div role="presentation" style={{ marginBottom: "16px" }}>
			<Breadcrumbs aria-label="breadcrumb" separator="›">
				{breadcrumbVoices.map((el, index) =>
					index < breadcrumbVoices.length - 1 ? (
						<StyledBreadcrumb
							key={`voice_${index}`}
							onClick={() => navigate(el.path)}
							label={el.text}
							icon={el.icon}
						/>
					) : (
						<Typography
							component="span"
							key={`voice_${index}`}
							color="text.primary"
						>
							{el.text}
						</Typography>
					)
				)}
			</Breadcrumbs>
		</div>
	)
}

export default Breadcrumb
